<template>
  <!-- 提现 连连 锐锢 -->
  <div class="withdrawal-wrap" v-loading="loading">
    <div class="company-list">
      <div @click="handleCompany(item)" v-for="(item, index) in corpList" :key="index"
        :class="activeCorp == item.corpId ? 'tag-company active-tag-company' : 'tag-company'">
        {{ item.corpName }}
      </div>
    </div>

    <div class="purse-card-wrap" v-if="loading == false">
      <!-- 连连钱袋 open 开户则显示 -->
      <CashCard v-if="lianLianAccountStatus.open" :cardInfo="LianLianCard" :purseInfo="lianInfo"
        :cashInfo="lianLianCashInfo" :supplierId="supplierId" :corpId="activeCorp"
        :lianLianAccountStatus="lianLianAccountStatus"></CashCard>

      <!-- 锐锢钱袋 -->
      <CashCard :cardInfo="RuiGuCard" :purseInfo="ruiGuInfo" :cashInfo="ruiGuCashInfo" :supplierId="supplierId"
        :corpId="activeCorp" :lianLianAccountStatus="lianLianAccountStatus"></CashCard>
    </div>

    <div class="tip-text" @click="showTip">*看不懂钱袋？点我了解钱袋字段说明</div>

    <!-- 钱袋字段说明 -->
    <el-dialog custom-class="tip-modal" title="钱袋字段说明" append-to-body center :visible.sync="tipVisible" width="460px"
      @close="handleClose">
      <div class="tip-content">
        <div class="tip-item">
          <span class="label">钱袋余额：</span>
          <span class="value">可提现金额+在途资金+金融冻结款+保证金</span>
        </div>
        <div class="tip-item">
          <span class="label">可提现金额：</span>
          <span class="value">可提现至银行卡的金额</span>
        </div>
        <div class="tip-item">
          <span class="label">未入账金额：</span>
          <span class="value">交易金额-已入账金额</span>
        </div>
        <!-- <div class="tip-item">
          <span class="label">在途资金：</span>
          <span class="value">已分账还未入钱袋的资金</span>
        </div>
        <div class="tip-item">
          <span class="label">保证金：</span>
          <span class="value">您在锐锢平台缴存或预留的保证金</span>
        </div>
        <div class="tip-item">
          <span class="label">冻结资金：</span>
          <span class="value">平台优先垫付给客户退款的资金</span>
        </div> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import CashCard from "./components/cashCard";
import {
  getCompanyList,
  getPurseList,
  cashRelateInfo,
  checkLian,
} from "@/models/purseSet";
const RuiGuCard = {
  type: "RuiGu",
  title: "锐锢钱袋",
};
const LianLianCard = {
  type: "LianLian",
  title: "连连钱袋",
};
export default {
  components: { CashCard },
  data() {
    return {
      corpList: [],
      supplierId: "",
      activeCorp: "", // 选中公司
      RuiGuCard,
      LianLianCard,
      lianInfo: {}, // 连连钱袋信息
      ruiGuInfo: {}, // 锐锢钱袋信息
      lianLianCashInfo: {}, // 连连提现信息
      ruiGuCashInfo: {}, //  锐锢提现信息
      lianLianAccountStatus: {}, // 连连账户状态信息 是否开户 open 是否激活 activation
      tipVisible: false, // 字段解释弹窗
      loading: false
    };
  },

  created() {
    this.supplierId = Number(window.localStorage.getItem("supplier_id"));
    this.initCompanyList();
  },

  methods: {
    // 初始化公司列表
    initCompanyList() {
      this.loading = true;
      const params = {
        supplierId: this.supplierId,
      };
      getCompanyList(params)
        .then((res) => {
          this.loading = false;
          if (res.data && res.data.length > 0) {
            // 过滤出有钱袋显示的公司 show == 1
            this.corpList = res.data.filter(item => item.show === 1);
            this.activeCorp = this.corpList[0].corpId;
            /*
              默认初始化第一个公司连连钱袋的账户状态信息 若未开户 则不显示连连钱袋卡片
              第一个公司钱袋信息
              锐锢钱袋提现信息
            */
            this.handleCompany(this.corpList[0]);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error(error.message);
        });
    },

    // 获取公司下钱袋列表
    initPurseList() {
      const params = {
        corpId: this.activeCorp,
        supplierId: this.supplierId,
        purchaseChannel: 4,
      };
      getPurseList(params)
        .then((res) => {
          if (res.data) {
            this.lianInfo = res.data.lianLianPurseInfo;
            this.ruiGuInfo = res.data.ruiGuPurseInfo;
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },

    // 获取公司提现相关信息 1锐锢钱袋 2 清分钱袋
    getCashInfo(type) {
      const params = {
        corpId: this.activeCorp,
        bindAccountType: type,
        supplierId: this.supplierId,
      };
      cashRelateInfo(params)
        .then((res) => {
          if (res.data) {
            // 锐锢钱袋提现信息
            if (type == 1) this.ruiGuCashInfo = res.data;
            // 连连钱袋提现信息
            if (type == 2) this.lianLianCashInfo = res.data;
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },

    // 切换公司
    async handleCompany(item) {
      this.activeCorp = item.corpId;
      try {
        // 获取选中公司 连连钱袋的账户状态信息 若未开户 则不显示连连交易明细
        const params = {
          corpId: this.activeCorp,
        };
        const res = await checkLian(params);
        this.lianLianAccountStatus = res.data;
        // 选中公司钱袋信息
        this.initPurseList();
        // 选中公司 锐锢钱袋提现信息
        this.getCashInfo(1);
        // 公司连连钱袋开户且账户激活 则获取连连提现信息
        if (this.lianLianAccountStatus.open && this.lianLianAccountStatus.activation) this.getCashInfo(2);
      } catch (error) {
        this.$message.error(error.message);
      }
    },

    // 显示
    showTip() {
      this.tipVisible = true;
    },

    // 关闭
    handleClose() {
      this.tipVisible = false;
    },
  },
};
</script>
<style lang="scss">
.withdrawal-wrap {
  padding: 20px 10px;

  .company-list {
    display: flex;
    font-size: 14px;
    font-weight: 600;

    .tag-company {
      padding: 8px 16px;
      background: rgba(0, 0, 0, 0.02);
      border-radius: 2px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      margin-right: 8px;
      cursor: pointer;
    }

    .active-tag-company {
      color: #ff6224;
    }
  }

  .purse-card-wrap {
    display: flex;
    margin-top: 20px;
  }

  .tip-text {
    color: #faad14;
    font-size: 14px;
    margin-left: 30px;
    margin-top: 20px;
    cursor: pointer;
  }
}

.tip-modal {
  border-radius: 8px;

  .el-dialog__header {
    background-color: #fff !important;
    text-align: left;
    padding: 20px 20px 0 !important;
    border-radius: 10px;
    position: relative;

    .el-dialog__title {
      color: #303133 !important;
      font-weight: bold;
    }

    .el-icon-close {
      color: #333 !important;
      margin-top: 10px;
    }
  }

  .tip-content {
    .tip-item {
      margin-bottom: 20px;
      display: flex;

      .label {
        color: #262626;
        width: 90px;
        text-align: right;
      }

      .value {
        color: #595959;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/purseSetting/withdrawal/withdrawal.vue